import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { AccessRightFilterSettings } from '@fi-shared/access-right-filters';
import { ModuleType } from '@fi-shared/types/module-type';
import { AccessRightFiltersComponent } from '@fi-shared/access-right-filters/access-right-filters.component';
import { ILightWeightTagForList } from '@fi-app/tag/tag';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { ObjectTypes } from '@fi-shared/types';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { SiteMapSortingTypes } from '@fi-app/site-map/site-map-consts';
import { ISiteMap } from '@fi-shared/models/site-map';

@Component({
    selector: 'fi-site-map-edit-general',
    templateUrl: './site-map-edit-general.component.html',
    styleUrls: ['./site-map-edit-general.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-site-map-edit-general' },
    providers: [{ provide: FiComponentsContainer, useExisting: SiteMapEditGeneralComponent }],
    standalone: false,
})
export class SiteMapEditGeneralComponent extends FiComponentsContainer implements OnInit {
    @Input() siteMap: ISiteMap;
    @Input() allTags: ILightWeightTagForList[];
    @Output() siteMapTagIdChange = new EventEmitter();
    @Output() siteMapSortTypeChange = new EventEmitter();
    @ViewChild(AccessRightFiltersComponent, { static: false }) accessRightFilters: AccessRightFiltersComponent;

    AccessRightFilterSettings = new AccessRightFilterSettings(ModuleType.Tag, false, true, ObjectTypes.Tag);

    optionDisabledFn: (item, items) => boolean = (item: ILightWeightTagForList, items: ILightWeightTagForList[]) =>
        !!item.ParentId;
    availableTags = new DropdownSettingsModelV2<ILightWeightTagForList>({
        filterBy: 'Name',
    });

    ngOnInit() {
        this.setListDataSettings();
    }

    private setListDataSettings() {
        const filteredTags: ILightWeightTagForList[] = this.allTags.filter((tag: ILightWeightTagForList) => {
            return !tag.SiteMapId || tag.SiteMapId === this.siteMap.Id;
        });
        this.availableTags.setDataSet(filteredTags);
    }

    onTagIdChange() {
        this.siteMapTagIdChange.emit();
    }

    onSortingTypeChanged() {
        this.siteMapSortTypeChange.emit();
    }

    protected readonly SiteMapSortingTypes = SiteMapSortingTypes;
}
